import React, { useState, useEffect } from "react";
import DataTable from "../components/appointments/DataTable";
import "../assets/css/appointments/appointments.scss";
import Chevron from "../assets/images/common/chevron-right.svg";
import AcceptModal from "../components/common/AcceptModal";
import CancelModal from "../components/common/CancelModal";
import AddAppointmentModal from "../components/appointments/AddAppointmentModal";
import CheckPatientModal from "../components/common/CheckPateintModal";
import Searchbar from "./../components/common/Searchbar";

// img
import DownIcon from "../assets/images/dashboard/DownIcon.svg";



const Appointments = () => {
  const [rows, setRows] = useState([
    {
      number: 1,
      name: " Sufian",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-11",
      time: "11:00AM",
      civilID: "40122-67366475-3",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Pending",
      prescription: "Aspirin 500mg",
    },
    {
      number: 2,
      name: "Abdullah",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-10",
      time: "11:00AM",
      civilID: "40122-67366475-4",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Pending",
      prescription: "Aspirin 500mg",
    },
    {
      number: 3,
      name: "Ahad",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-12",
      time: "11:00AM",
      civilID: "40122-67366475-5",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Pending",
      prescription: "Aspirin 500mg",
    },
    {
      number: 4,
      name: "Azlan",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-03",
      time: "11:00AM",
      civilID: "40122-67366475-6",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Pending",
      prescription: "Aspirin 500mg",
    },
    {
      number: 5,
      name: "Ayan",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-11",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Pending",
      prescription: "Aspirin 500mg",
    },
    {
      number: 6,
      name: "Sufian",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-12",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Pending",
      prescription: "Aspirin 500mg",
    },
    {
      number: 7,
      name: "Caliph",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-30",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Approved",
      prescription: "Aspirin 500mg",
    },
    {
      number: 8,
      name: "Johnson",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-14",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Approved",
      prescription: "Aspirin 500mg",
    },
    {
      number: 9,
      name: "William",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-14",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Approved",
      prescription: "Aspirin 500mg",
    },
    {
      number: 10,
      name: "Sufiyan",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-15",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Approved",
      prescription: "Aspirin 500mg",
    },
    {
      number: 11,
      name: "Malok",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-15",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Approved",
      prescription: "Aspirin 500mg",
    },
    {
      number: 12,
      name: "Asad",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-13",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "pending",
      prescription: "Aspirin 500mg",
    },
    {
      number: 13,
      name: "Umair",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-28",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Approved",
      prescription: "Aspirin 500mg",
    },
    {
      number: 14,
      name: "Dan",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-13",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Approved",
      prescription: "Aspirin 500mg",
    },
    {
      number: 15,
      name: "Dan",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-11",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Approved",
      prescription: "Aspirin 500mg",
    },
    {
      number: 16,
      name: "Dan",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-12",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Approved",
      prescription: "Aspirin 500mg",
    },
    {
      number: 17,
      name: "Dan",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-10",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Approved",
      prescription: "Aspirin 500mg",
    },
    {
      number: 18,
      name: "Dan",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-12",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Approved",
      prescription: "Aspirin 500mg",
    },
    {
      number: 19,
      name: "Dan",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-11",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Approved",
      prescription: "Aspirin 500mg",
    },
    {
      number: 20,
      name: "Sameer",
      email: "johndoe@example.com",
      age: 35,
      gender: "male",
      specialization: "Cardiology",
      date: "2023-04-10",
      time: "11:00AM",
      civilID: "40122-67366475-7",
      doctor: "Dr. Jane Smith",
      fees: "$50/Patient",
      appointmentStatus: "Approved",
      prescription: "Aspirin 500mg",
    },
  ]);
  const [isActive, setIsActive] = useState(false);
  const [filterOption, setFilterOption] = useState("All"); // default to "today"
  const [searchQuery, setSearchQuery] = useState("");
  const [showCheckPatientModal, setShowCheckPatientModal] = useState(false);
  const [showTickModal, setShowTickModal] = useState(false);
  const [showCrossModal, setShowCrossModal] = useState(false);
  const [showAddAppointmentModal, setshowAddAppointmentModal] = useState(false);
  const navigate = "/appointment";

  function toggleDropdown(data) {
    setIsActive(!isActive);
    setFilterOption(data)
  }

  //  AcceptAppointModal handler
  const handleTickClick = () => {
    setShowTickModal(true);
  };

  //  CancelAppointentModal handlar
  const handleCrossClick = () => {
    setShowCrossModal(true);
  };

  const handleAddAppointment = () => {
    setshowAddAppointmentModal(true);
  };

  useEffect(() => {
    if (navigate === "/appointment") {
      setShowCheckPatientModal(true);
    }
  }, [navigate.location]);

  //  On page render pateint modal
  const handleCloseCheckPatientModal = () => {
    setShowCheckPatientModal(false);
  };

  //  Filter handler
  const handleFilterChange = (event) => {
    setFilterOption(event.target.value);
  };

  //  Accept appointment handler
  const handleAcceptAppointment = () => {
    // Find the index of the appointment row that needs to be updated
    const rowIndex = rows.findIndex(
      (row) => row.appointmentStatus === "Pending"
    );
    if (rowIndex !== -1) {
      // Update the appointment status to "Approved"
      const updatedRows = [...rows];
      updatedRows[rowIndex] = {
        ...updatedRows[rowIndex],
        appointmentStatus: "Approved",
      };
      setRows(updatedRows); // Update the state of rows
    }
  };

  // Search Functionality
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <>
      {/* <CheckPatientModal
        open={showCheckPatientModal}
        onClose={handleCloseCheckPatientModal}
      /> */}

      <AcceptModal
        heading="Accept Appointment"
        description="Are you sure you want to Accept an appointment?"
        open={showTickModal}
        onClose={() => setShowTickModal(false)}
        onAccept={handleAcceptAppointment}
      />
      <CancelModal
        heading="Cancel Appointment"
        description="Are you sure you want to cancel an appointment?"
        open={showCrossModal}
        onClose={() => setShowCrossModal(false)}
      />
      <AddAppointmentModal
        open={showAddAppointmentModal}
        onClose={() => setshowAddAppointmentModal(false)}
      />

      <div className="row pl-3 pr-2 pt-4 appointment-tab">
        <div className="col-12">
          <p className="mb-0 appointment-heading">Appointment</p>
        </div>

        <div className="col-12 my-4">
          <div className="row">
            <div className="col-md-6">
              <p className="appointment-breadcrumb">
                <span> DASHBOARD </span>
                <img src={Chevron} />
                <span className="current-tab"> APPOINTMENT</span>
              </p>
            </div>
            <div class="col-md-6 text-md-right">
              {/* <select
                style={{ marginRight: "15px" }}
                value={filterOption}
                onChange={handleFilterChange}
              >
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="tomorrow">Tomorrow</option>
              </select> */}

              <div className={`dropdown ${isActive ? 'active' : ''}`}>
                <button className="doctor-btn patient-btn-filter mr-3"  onClick={()=>{
                      setIsActive(!isActive)
                      
                  }} style={{height:"48px", width:"100px"}}>
                {filterOption} <img className="pl-2" src={DownIcon} alt="" />
                </button>

                <div className="dropdown-content border"
                  style={{
                    display: isActive ? 'block' : 'none',
                    width: "97px",

                  }}>
                  <div className='old-dropdown-text1 text-center' onClick={()=>{
                      setIsActive(!isActive)
                      setFilterOption('Today')
                  }}>
                    <span>Today</span>
                  </div>
                  <div className='old-dropdown-text2 text-center' onClick={()=>{
                      setIsActive(!isActive)
                      setFilterOption('Tomorrow')
                  }}>
                    <span>Tomorrow</span>
                  </div>
                  <div className='old-dropdown-text2 text-center' onClick={()=>{
                      setIsActive(!isActive)
                      setFilterOption('Yesterday')
                  }}>
                    <span>Yesterday</span>
                  </div>
                </div>
              </div>


              <button
                type="button"
                class="add-appointment"
                onClick={handleAddAppointment}
              >
                Add Appointment
              </button>
            </div>
          </div>

          <div className="row m-0 p-0">
            <Searchbar onChange={handleSearchChange} value={searchQuery} />
          </div>
        </div>

        <div className="col-12  mb-5 pb-5">
          <DataTable
            rows={rows}
            onTickClick={handleTickClick}
            onCrossClick={handleCrossClick}
            filterOption={filterOption}
            searchQuery={searchQuery}
          />
        </div>
      </div>
    </>
  );
};

export default Appointments;
